import React from "react";
import PropTypes from "prop-types";
import NavTabs from "~components/NavTabs";

const RotaDoDiaLayout = ({ children, customTabs }) => {
  const tabs = customTabs ?? [
    { name: "Rota do Dia", link: "/roteirizacao/mapa" },
    { name: "Histórico de Visitas", link: "/roteirizacao/visitas" },
  ];
  return (
    <div data-testid="layout-container" className="container ">
      <NavTabs navs={tabs} />
      {children}
    </div>
  );
};

RotaDoDiaLayout.propTypes = {
  children: PropTypes.node,
  customTabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      link: PropTypes.string,
    })
  ),
};

export default RotaDoDiaLayout;
